module.exports = __webpack_public_path__ + "static/media/qr-icon.053cdb20.svg";